import Link from 'next/link';

import Head from '~/components/Meta/Head';

import { fetchAgentHtmlSitemapStates } from '~/utils/Fetch/Location';
import Breadcrumb from '~/components/Breadcrumb';
import ContentWrapper from '~/components/ContentWrapper';
import { provinces, states } from '~/utils/Provinces';
import { notifyBugSnag } from '../../utils/ErrorChecking';
import SitemapHTML from '../../components/SitemapHTML';
import styles from './index.module.scss';
import Heading from '@referralexchange/rea-ui-react/src/atoms/Heading';

const Index = (props) => {
  const { pageData } = props;
  const { locations } = pageData;

  const breadcrumb = {
    crumbs: ['RealEstateAgents.com', 'Agent Directory'],
    asPath: ['/', '/agents-directory'],
    pathname: ['/', '/agents-directory'],
  };

  const renderUSLocations = () => {
    if (locations && locations?.us?.length > 0) {
      return locations?.us?.map((location, index) => (
        <span className={styles.directory__link}>
          <Link
            prefetch={false}
            key={index}
            href="/agents-directory/[sitemap_state]/[page]"
            as={`/agents-directory/${location.short.toLowerCase()}/1`}
          >
            {location.name}
          </Link>
        </span>
      ));
    }
    return null;
  };

  const renderCALocations = () => {
    if (locations && locations?.ca?.length > 0) {
      return locations?.ca?.map((location, index) => (
        <span className={styles.directory__link}>
          <Link
            prefetch={false}
            key={index}
            href="/agents-directory/[sitemap_state]/[page]"
            as={`/agents-directory/${location.short.toLowerCase()}/1`}
          >
            {location.name}
          </Link>
        </span>
      ));
    }
    return null;
  };

  return (
    <div className={styles.directory}>
      <Head
        url={`${process.env.CLIENT_ORIGIN}/agents-directory`}
        title="Agents Directory | RealEstateAgents.com"
        description="A directory of the top real estate agents in the United States to support you as a home buyer or seller."
      />
      <ContentWrapper>
        <Breadcrumb
          passedAsPath={breadcrumb && breadcrumb.asPath}
          passedPathname={breadcrumb && breadcrumb.pathname}
          passedCrumbs={breadcrumb && breadcrumb.crumbs}
          breadcrumbReady
          noCheck
        />
        <Heading tag="h1" type="h1">
          Find an Agent
        </Heading>
        <SitemapHTML
          breadcrumb={breadcrumb}
          title="Agents in the United States"
          description="Find the perfect real estate agent in any state."
          renderItems={renderUSLocations}
          headingType="h2"
        />
        <SitemapHTML
          breadcrumb={breadcrumb}
          title="Agents in Canada"
          description="Find the perfect real estate agent in any province."
          renderItems={renderCALocations}
          headingType="h2"
        />
      </ContentWrapper>
    </div>
  );
};

export async function getStaticProps(ctx) {
  try {
    const locations = await fetchAgentHtmlSitemapStates();

    const us_locations = [];

    states.map((item) => {
      if (locations.us.includes(item.short)) {
        us_locations.push({ name: item.name, short: item.short });
      }
    });

    const ca_locations = [];

    provinces.CA.map((item) => {
      if (locations.ca.includes(item.short)) {
        ca_locations.push({ name: item.name, short: item.short });
      }
    });

    const pageData = {
      locations: {
        us: us_locations,
        ca: ca_locations,
      },
    };

    return {
      props: { pageData },
      revalidate: 60 * 5,
    };
  } catch (err) {
    console.log(err);
    const bugSnagMetadata = [
      {
        label: 'route',
        fields: {
          asPath: ctx.asPath,
          pathname: ctx.pathname,
          server_context: ctx,
          server: !!ctx.req,
        },
      },
      {
        label: 'ctx error',
        fields: {
          ctx_error: ctx.error,
        },
      },
    ];
    notifyBugSnag({ error: err, metadata: bugSnagMetadata });
    return { props: { pageData: {}, error: { code: 500 } }, revalidate: 1 };
  }
}
export default Index;
